// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__NErhW","title":"Header_title__1VGYr","side":"Header_side__2NanW"};